import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M11.662 16.018V2.4M14.96 12.707l-3.299 3.311-3.297-3.311",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.901 7.753h1.055a4.166 4.166 0 0 1 4.167 4.167v5.524a4.156 4.156 0 0 1-4.157 4.156H5.368A4.17 4.17 0 0 1 1.2 17.433v-5.525a4.156 4.156 0 0 1 4.156-4.155h1.066",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }